// eslint-disable-next-line import/no-default-export
class HeaderScroll extends HTMLElement {
  constructor () {
    super()

    this.isTicking = false
    // eslint-disable-next-line
    this.lastKnownY = window.scrollY
    this.offsetTrackedY = 0
    this.scrollOffset = 300
    this.safeZone = 100
    this.scrollDirection = ''

    this.setupListeners()

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)

    this.updateEl()
  }

  setupListeners () {
    this.onScroll = this.onScroll.bind(this)

    window.addEventListener('scroll', this.onScroll, { passive: true })
  }

  onScroll () {
    const previouslyKnown = this.lastKnownY
    const previousDirection = this.scrollDirection

    // eslint-disable-next-line
    this.lastKnownY = window.scrollY
    this.scrollDirection = previouslyKnown < this.lastKnownY ? 'down' : 'up'

    if (previousDirection !== this.scrollDirection) {
      this.offsetTrackedY = this.lastKnownY
    }

    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.setFixed()
    this.setVisibility()
  }

  setFixed () {
    this.classList.toggle('hd-Banner-fixed', this.shouldBeFixed)
    document.body.classList.toggle('lyt-Site-headerFixed', this.shouldBeFixed)
  }

  setVisibility () {
    const searchIsActive = document.body.classList.contains(
      'lyt-Site-searchIsActive',
    )

    if (searchIsActive) return

    this.classList.toggle('hd-Banner-hidden', !this.shouldBeVisible)
    document.body.classList.toggle(
      'lyt-Site-headerVisible',
      this.shouldBeVisible,
    )
  }

  get shouldBeFixed () {
    return this.lastKnownY >= this.safeZone
  }

  get shouldBeVisible () {
    if (this.lastKnownY <= this.offsetHeight + this.safeZone * 2) {
      return true
    }

    if (this.scrollDirection === 'down') {
      return !this.isOverOffset
    } else if (this.scrollDirection === 'up') {
      return this.isOverOffset
    }
  }

  get isOverOffset () {
    if (this.scrollDirection === 'down') {
      return this.lastKnownY >= this.offsetTrackedY + this.scrollOffset
    } else if (this.scrollDirection === 'up') {
      return this.lastKnownY <= this.offsetTrackedY - this.scrollOffset
    }
  }

  get containerEl () {
    return this.closest('[data-header-container-el]')
  }
}

customElements.define('header-scroll', HeaderScroll)
